<ng-container *transloco="let t">
  <ng-container *ngIf="visible === true">
    <!-- @todo opening per ng-container? [visible] doesnt work :-( -->
    <p-dialog [visible]="true" [closable]="false" class="settings-dialog" styleClass="dialog-full" [draggable]="false">

      <p-header>
        <span *ngIf="mode === 'start'">{{ t('partials.exercise_settings.start_exercise') }}: <strong>{{ exercise?.title }}</strong></span> <!-- @deprecated? -->
        <span *ngIf="mode === 'settings'">
          {{ t('partials.exercise_settings.settings') }}:
          <strong> {{ exercise?.title }}</strong>
          <ng-container *ngIf="ac.isGroup() && exercise.isTeam()"> ({{ t('common.labels.team_exercise') }})</ng-container>
          <ng-container *ngIf="ac.isGroup() && exercise.isIndividual()"> ({{ t('common.labels.individual_exercise') }})</ng-container>
        </span>
      </p-header>

      <form (submit)="saveSettings()" novalidate>

        <app-tab-selector
          [tabs]="tabs"
          [(active)]="activeTab"
        ></app-tab-selector>

        <div [hidden]="activeTab === null || activeTab.value !== 'groups'">
          <app-exercise-settings-groups
            [ac]="ac"
            [exercise]="exercise"
            [matrix]="has_matrix"
            #groups
          ></app-exercise-settings-groups>
        </div>
        <div [hidden]="activeTab === null || activeTab.value !== 'slots'">
          <app-exercise-settings-slots
            [ac]="ac"
            [exercise]="exercise"
            #slots
          ></app-exercise-settings-slots>
        </div>

        <div class="p-grid p-mt-4">
          <div class="p-col p-d-flex p-ai-center">
            <ng-container *ngIf="ac?.isGroup() && exercise?.isIndividual() === true">
              <div>
                <p-inputSwitch [(ngModel)]="automatic_start" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
              </div>
              <div class="p-ml-2">{{ t('partials.exercise_settings.automatic_start') }}</div>
            </ng-container>
            <ng-container *ngIf="exercise?.isTeam() === true">
              <div>
                <p-inputSwitch [(ngModel)]="has_matrix" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
              </div>
              <div class="p-ml-2">{{ t('partials.exercise_settings.has_matrix') }}</div>
            </ng-container>
          </div>
          <div class="p-col p-text-right">
            <app-form-buttons [submitting]="submitting" (cancelled)="hideSettings()" [submitLabel]="(mode === 'start') ? t('common.labels.start') : t('common.labels.save')"></app-form-buttons>
          </div>
        </div>

      </form>

    </p-dialog>
  </ng-container>
</ng-container>
